import { uiTypes } from 'shared-components';
import * as types from 'api-paths-cas';
import { ICalendlyEvent } from 'api-paths-cas';
// Stack 28-types Stage 5 leftovers: these symbols live in platform-lib
// fe-safe but aren't re-exported through api-paths-cas. Aliased so the local
// same-named interface declarations below can `extends`-them.
import type {
  ITravelStatusSection as PlatformITravelStatusSection,
  CustomRequest as PlatformCustomRequest,
  DepositDoc as PlatformDepositDoc,
  FamilySponsorshipDoc as PlatformFamilySponsorshipDoc,
  Organisation as PlatformOrganisation,
  Scholarship as PlatformScholarship,
  Education as PlatformEducation,
  ISummary as PlatformISummary,
  IFinanceDocuments as PlatformIFinanceDocuments,
  IUser as PlatformIUser,
  IMessage as PlatformIMessage,
} from 'platform-lib/fe-safe';
import { MaritalStatus, Relationship } from 'platform-lib/fe-safe';


export enum NamedRoutes {
  ADMISSIONS_WORKFLOW = '/admissions',
  ROOT = '/',
}

export type FilterArray = Array<{ filterKey: string; value: string; label: string }>;

export enum QueryKeys {
  SEARCH = 'search',
  UNI = 'uni',
  INTAKE_ID = 'intakeId',

  APPLICATION_STAGE = 'applicationStage',
  OFFER_STAGE = 'offerStage',
  STAGE = 'stage',

  CURRENT_TAB = 'current-tab',
  SORT_COL = 'sort-col',
  SORT_DIR = 'sort-dir',
  PAGE = 'page',
  UNREAD_MESSAGES = 'unread_messages',
}

export interface IAnyObj {
  [key: string]: any;
}

export type IModal = uiTypes.IModal;
export type IDate = uiTypes.IDate;
export type ICheckbox = uiTypes.ICheckbox;
export type IQuestion = uiTypes.IQuestion;

export const { UploadFileStatus } = uiTypes;

export type IMrzData = types.IMrzData;

export type ISystemAndUniConfig = types.ISystemAndUniConfig;

export interface IConfigState extends ISystemAndUniConfig {
  regionInterviewConfig: Array<types.IRegionInterviewConfig>;
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  pathwayPartnerConfig: types.IUniConfig | {};
  scholarships: types.ApplyScholarship[];
  isLoaded: boolean;
  navigationUrls?: {
    apply?: string;
    casStudent?: string;
    casStaff?: string;
  };
  featureFlags: Record<string, boolean>;
  admAllowedAliases?: string[];
}

export type IFieldMappingList = types.IFieldMappingList;

export type IRegionConfigForSave = types.IRegionConfigForSave;
export type IRegionConfigForUpdate = types.IRegionConfigForUpdate;
export type IDataCountry = types.IDataCountry;

export const { CountryCategory } = types;
export type CountryCategory = types.CountryCategory;

export type MaturityStatus = types.MaturityStatus;
export interface ITravelStatus extends PlatformITravelStatusSection {
  requestNewTravelTicket?: boolean;
}
export type ITag = types.ITag;

export interface IOtherNationality {
  nationality: string;
  isCurrent?: boolean;
}

export interface ISponsorDetails {
  licenceNumber: string;
  schoolName: string;
  address: string;
  city: string;
  postcode: string;
}
export interface ICountry {
  name: string;
  atas: boolean;
  tb: boolean;
  riskLevel: number;
}

export interface IOtherName {
  surname: string;
  givenName: string;
  reason: string;
}

export interface IStudentVisa {
  visaType: string;
  level: string;
  year: string;
  isComplete?: boolean;
  incompleteReason?: string;
  isIncompleteRecorded?: boolean;
  isVisaShortened?: boolean;
  shortenedDate?: string;
}

export interface IStudentOtherVisa {
  visaType: string;
  year: string;
}
export interface IStudentVisaRefusal {
  visaType: string;
  year: string;
}

export interface IStudentNonUKVisaRefusal {
  country: string;
  isStudentVisa?: boolean;
  year: string;
}

export interface PreviousVisa {
  type: string;
  year: string;
}

export interface IPreviousNonUKVisa {
  countryIssued: string;
  isStudentVisa?: boolean;
  yearIssued: string;
}

export interface PreviousStudyVisa extends PreviousVisa {
  type: string;
  level: string;
  year: string;
  complete?: boolean;
  incomplete?: string;
  nonCompletionOnRecord?: string;
  shortened?: string;
  shortenedDate?: IDate;
  [key: string]: string | IDate | boolean | undefined;
}

export type IDocument = types.IDocument;

export interface DocumentMap {
  [key: string]: IDocument;
}
export interface IDocumentsList {
  key: string;
  item: IDocument;
}

export interface StudentVisaMap {
  [key: string]: StudentVisaDocuments;
}

export interface StudentVisaDocMap {
  [key: string]: StudentVisaDoc;
}

export interface StudentVisaDocList {
  key: string;
  item: types.StudentVisaDoc;
}

export interface StudentRefusalLetterDocList {
  key: string;
  item: types.StudentRefusalLetterDoc;
}

export type StudentVisaDocuments = types.StudentVisaDocuments;

export interface BiometricDocumentMap {
  [key: string]: BiometricDocument;
}

export interface BiometricDocumentList {
  key: string;
  item: BiometricDocument;
}

export type BiometricDocument = types.BiometricDocument;

export type PassportDocs = types.PassportDocs;

export interface PassportMap {
  [key: string]: PassportDoc;
}

export interface PassportList {
  key: string;
  item: PassportDoc;
}

export type PassportDoc = types.PassportDoc;

export interface StudentVisaDocList {
  key: string;
  item: StudentVisaDoc;
}

export type StudentVisaDoc = types.StudentVisaDoc;

export type VisaRefusalDoc = types.VisaRefusalDoc;

export interface UKVisaRefusalMap {
  [key: string]: UKVisaRefusal;
}

export interface VisaRefusalDocMap {
  [key: string]: VisaRefusalDoc;
}

export interface VisaRefusalDocList {
  key: string;
  item: VisaRefusalDoc;
}

export type UKVisaRefusal = types.UKVisaRefusal;

export interface NonUKVisaRefusalMap {
  [key: string]: NonUKVisaRefusal;
}

export type NonUKVisaRefusal = types.NonUkVisaRefusal;

export type OVisa = types.OtherVisa;

export type VisaRefusal = types.VisaRefusal;
export interface OtherVisaMap {
  [key: string]: OtherVisaDocs;
}

export interface OtherVisaList {
  key: string;
  item: OtherVisaDoc;
}

export type OtherVisaDoc = types.OtherVisaDoc;
export type OtherVisaDocs = types.OtherVisaDocs;

export interface ParentalConsentMap {
  [key: string]: ParentalConsent;
}

export interface ParentalConsentList {
  key: string;
  item: ParentalConsent;
}

export type ParentalConsent = types.ParentalConsent;

export interface TBTestMap {
  [key: string]: TBTest;
}

export interface TBTestList {
  key: string;
  item: TBTest;
}

export type TBTest = types.TBTest;

export interface ATASMap {
  [key: string]: ATAS;
}

export interface ATASList {
  key: string;
  item: ATAS;
}

export type ATAS = types.ATAS;

export interface CustomRequestMap {
  [key: string]: CustomRequest;
}

export interface CustomRequest extends PlatformCustomRequest {
  [key: string]: any;
}

export interface IDocuments {
  cas: DocumentMap;
  passport: PassportDocs;
  academicTranscript: DocumentMap;
  academicCertificate: DocumentMap;
  studentVisas: StudentVisaMap;
  visaRefusals: UKVisaRefusalMap;
  nonUkVisaRefusals: NonUKVisaRefusalMap;
  otherVisas: OtherVisaMap;
  parentalConsent: ParentalConsentMap;
  birthCertificate: BirthCertificateDocs;
  tbTest: TBTestMap;
  atas: ATASMap;
  englishTest: DocumentMap;
  customRequest: CustomRequestMap;
  postStudyLetter: DocumentMap;
  documentsRequired?: number;
  documentsComplete?: number;
  isSectionStarted?: boolean;
  isSectionComplete?: boolean;
  [key: string]: any;
}

export type IFollowUpDocuments = types.IFollowUpDocuments;
export type IEnrolmentStatus = types.IEnrolmentStatus;
export interface IArrivalStatus extends PlatformITravelStatusSection {
  requestNewTravelTicket?: boolean;
}

export type BiometricResidencePermitDoc = types.BiometricResidencePermitDoc;
export interface BiometricResidencePermitDocList {
  key: string;
  item: BiometricResidencePermitDoc;
}

export type TravelTicketDoc = types.TravelTicketDoc;
export interface TravelTicketDocList {
  key: string;
  item: TravelTicketDoc;
}

export type VisaApplicationPdfCopyDoc = types.VisaApplicationPdfCopyDoc;
export interface VisaApplicationPdfCopyDocList {
  key: string;
  item: VisaApplicationPdfCopyDoc;
}

export type VisaVignetteDoc = types.VisaVignetteDoc;
export interface VisaVignetteDocList {
  key: string;
  item: VisaVignetteDoc;
}

export interface DepositDoc extends PlatformDepositDoc {
  [key: string]: any;
}

export type BirthCertificateDocs = types.BirthCertificateDocs;

export interface BirthCertificateDocMap {
  [key: string]: BirthCertificateDoc;
}
export interface BirthCertificateDocList {
  key: string;
  item: BirthCertificateDoc;
}

export type BirthCertificateDoc = types.BirthCertificateDoc;

export interface FamilySponsorshipDocMap {
  [key: string]: FamilySponsorshipDoc;
}

export interface BankStatementDocMap {
  [key: string]: BankStatementDoc;
}

export interface BankStatementDocList {
  key: string;
  item: BankStatementDoc;
}

export type BankStatementDoc = types.BankStatementDoc;

export interface ParentLetterDocMap {
  [key: string]: ParentLetterDoc;
}

export interface ParentLetterDocList {
  key: string;
  item: ParentLetterDoc;
}

export type ParentLetterDoc = types.ParentLetterDoc;

export interface BankLetterMap {
  [key: string]: BankLetterDoc;
}

export interface BankLetterList {
  key: string;
  item: BankLetterDoc;
}

export type BankLetterDoc = types.BankLetterDoc;

export interface FamilySponsorshipDoc extends PlatformFamilySponsorshipDoc {
  [key: string]: any;
}

export interface OrganisationDocsMap {
  [key: string]: Organisation;
}

export interface Organisation extends PlatformOrganisation {
  [key: string]: any;
}

export interface OrganisationDocMap {
  [key: string]: OrganisationDoc;
}

export interface OrganisationDocList {
  key: string;
  item: OrganisationDoc;
}

export type OrganisationDoc = types.OrganisationDoc;

export interface ScholarshipDocsMap {
  [key: string]: Scholarship;
}

export interface Scholarship extends PlatformScholarship {
  [key: string]: any;
}

export interface ScholarshipDocMap {
  [key: string]: ScholarshipDoc;
}

export interface ScholarshipDocList {
  key: string;
  item: ScholarshipDoc;
}

export type ScholarshipDoc = types.ScholarshipDoc;

export interface EducationDocsMap {
  [key: string]: Education;
}

export interface Education extends PlatformEducation {
  [key: string]: any;
}

export interface EducationDocMap {
  [key: string]: EducationDoc;
}

export interface EducationDocList {
  key: string;
  item: EducationDoc;
}

export type EducationDoc = types.EducationDoc;

export interface OtherDocMap {
  [key: string]: OtherDoc;
}

export interface OtherDoc {
  label: string;
  amount: number;
}

export interface IFinanceDocuments extends PlatformIFinanceDocuments {
  [index: string]: any;
}

export const { DocAccessType } = types;
export type DocAccessType = types.DocAccessType;

export interface IRegionOffice {
  id: string;
  name: string;
  desc: string;
  type: types.RegionOfficeType;
  country?: Array<string>;
  city?: string;
  postcode?: string;
}

export interface IAuditLog {
  who: string;
  action: string;
  when: number;
  role: string;
}

export type IRegionConfig = types.IRegionConfig;

export type IRegionConfigs = types.IRegionConfigs;

export type IRegionConfigWithFilters = types.IRegionConfigWithFilters;

export type IAgent = types.IAgent;

export type IAgencyOffice = types.IAgencyOffice;

export interface IAgentFromAPI {
  id: string;
  displayName: string;
  agentName: string;
  contactEmail: string;
  offices: any;
}

export interface IUsersListFromAPI {
  users: IUser[];
  numberOfUsers: number;
  paginationToken?: string;
}

export interface IUser extends PlatformIUser {
  [key: string]: any;
}

export interface IUserAttributes {
  givenName?: string;
  familyName?: string;
  email?: string;
  userRole?: string;
  agency?: string;
  pathway?: string;
  pathwayAccess?: 'Full' | 'Partial' | 'None';
}

export type IConsents = types.IConsents;

export type ICore = types.ICore;

export interface APICall {
  callName: string;
  retryNumber: number;
  timeToNextCall: number;
  hasFailed: boolean;
  error?: string;
  componentIds?: string[];
}

export interface IIntake {
  label: string;
  value: string;
  preSessionalCourses: IPreSessionalCourse[];
}

export interface IPreSessionalCourse {
  course: string;
  semester: string;
  courseFee: number;
  duration: string;
  startDate: string;
  studyMode: string;
}

export type ICourse = types.ICourse;

export type IPersonalInfo = types.IPersonalInfo;

export type IHistory = types.IHistory;

export type OtherVisa = types.OtherVisa;
// export type VisaRefusal = types.VisaRefusal; // eslint-disable-line @typescript-eslint/no-redeclare

export type FundingSummary = types.FundingSummary;

export type OrganisationSponsorshipMap = types.OrganisationSponsorshipMap;
export type OrganisationSponsorship = types.OrganisationSponsorship;
export type ScholarshipSponsorshipMap = types.ScholarshipSponsorshipMap;
export type ScholarshipSponsorship = types.ScholarshipSponsorship;
export type EducationSponsorshipMap = types.EducationSponsorshipMap;
export type EducationSponsorship = types.EducationSponsorship;
export type FamilySponsorshipMap = types.FamilySponsorshipMap;
export type FamilySponsorship = types.FamilySponsorship;
export const { FamilySponsorType } = types;
// export type FamilySponsorType = types.FamilySponsorType; // eslint-disable-line @typescript-eslint/no-redeclare
export type OtherSponsorshipMap = types.OtherSponsorshipMap;
export type OtherSponsorship = types.OtherSponsorship;

export type IFinance = types.IFinance;

export type IPreCasInterview = types.IPreCasInterview;

export interface ISummary extends PlatformISummary {
  [key: string]: any;
}

export type IRisk = types.IRisk;

export type IFundingRisk = types.IFundingRisk;

export type IAdditionalPassport = types.IAdditionalPassport;

export type IOtherUkVisas = types.IOtherUkVisas;

export type ITripToUk = types.ITripToUk;

export type IExclusionOrder = types.IExclusionOrder;

export type ILeaveToRemain = types.ILeaveToRemain;

export type IBorderRefusal = types.IBorderRefusal;

export type IDeportation = types.IDeportation;

export type IChildDetails = types.IChildDetails;

export { MaritalStatus };
// export type MaritalStatus = types.MaritalStatus; // eslint-disable-line @typescript-eslint/no-redeclare

export { Relationship };
// export type Relationship = types.Relationship; // eslint-disable-line @typescript-eslint/no-redeclare

export type IOtherTravellers = types.IOtherTravellers;

export type IFamilyMember = types.IFamilyMember;

export type ITravelItems = types.ITravelItems;

export interface IPhone {
  code: string | null;
  phone: string | null;
}

export type IVisaPrepForm = types.IVisaPrepForm;

export interface IMessage extends PlatformIMessage {
  isMessageSaving?: boolean;
  isMessageError?: boolean;
  authorName: string;
}

export interface IVisa {
  core: ICore;
  offer: types.IOffer;
  personalInfo: IPersonalInfo;
  history: IHistory;
  financials: IFinance;
  consents: IConsents;
  documents: IDocuments;
  financeDocuments: IFinanceDocuments;
  followUpDocuments: IFollowUpDocuments;
  enrolmentStatus: IEnrolmentStatus;
  preCasInterview: IPreCasInterview;
  visa: IVisaPrepForm;
  summary: ISummary;
  risks: IRisk;
  messages: IMessage[];
  importData: IImportData;
  conflictHistory: IConflictHistory;
  calendlyEvents: ICalendlyEvent[];
}

export type IConflictHistory = types.IConflictHistory;

export type IImportData = types.IImportData;

export type IImportCourse = types.IImportCourse;

export type InputFieldConfig = types.InputFieldConfig;

export interface IPropertyUpdate {
  property: string;
  value: any;
}

export interface IFundingSourceText {
  id: string;
  label: string;
  button: string;
  buttonAlt: string;
  saveButtonText: string;
}

export interface IRestrictedBanks {
  [key: string]: IRestrictedBank[];
}

export interface IRestrictedBank {
  bank: string;
  isAccepted: boolean;
}

export type IStudentConfig = types.IConfigDefault & types.IRegionConfig;

// export type IRegionConfig = types.IRegionConfig; // eslint-disable-line @typescript-eslint/no-redeclare
export const { OptionStatusType } = types;
// export type OptionStatusType = types.OptionStatusType; // eslint-disable-line @typescript-eslint/no-redeclare

export const { DocStatusType } = types;
// export type DocStatusType = types.DocStatusType; // eslint-disable-line @typescript-eslint/no-redeclare

export const { FollowUpDocStatusType } = types;
// export type FollowUpDocStatusType = types.FollowUpDocStatusType; // eslint-disable-line @typescript-eslint/no-redeclare

export const { SectionStatusType } = types;
// export type SectionStatusType = types.SectionStatusType; // eslint-disable-line @typescript-eslint/no-redeclare

export const { RegionConfigType } = types;
// export type RegionConfigType = types.RegionConfigType; // eslint-disable-line @typescript-eslint/no-redeclare

export type MfaSetupSettingsType = { mfaMethod: string; phoneNumber?: string };

export enum SectionId {
  CHECKLIST = 'CHECKLIST',
  GENERAL_DOC = 'GENERAL_DOC',
  FINANCE_DOC = 'FINANCE_DOC',
  PRE_CAS_INTERVIEW = 'PRE_CAS_INTERVIEW',
  VISA_PREP = 'VISA_PREP',
  CAS_DOC = 'CAS_DOC',
  COMPLETE = 'COMPLETE',
  ENROLMENT = 'ENROLMENT',
  FOLLOW_UP_DOCUMENTS = 'FOLLOW_UP_DOCUMENTS',
  SCHEDULED_INTERVIEWS = 'SCHEDULED_INTERVIEWS',
}

export type IRecordedInterviewAverageScoresExtended = types.IRecordedInterviewAverageScores & {
  facialRecognitionScore?: number | string;
  isReadingFromScript?: boolean;
  isLipSyncing?: boolean;
};

export type IRecordedInterviewScoresExtended = types.IRecordedInterviewScores & {
  facialRecognitionScore?: number | string;
};

export interface IOutletContext {
  interview: types.IRecordedInterviewEntry;
  canViewScoresAndAssessment: boolean;
  canEditScoresAndAssessment: boolean;
}

export interface AuditlogResponse {
  uni: string;
  student_no: string;
  intake_id: string;
  offer_id: string;
  audit: Array<IAuditLog>;
}

export interface ApplyOfferUpdateProps {
  applicantId: string;
  uni: string;
  offerId: string;
}
